import { Avatar, Box, Stack, Typography } from '@mui/material';
import { IFigurant } from 'models/backgroundActor';
import { DocumentType } from 'commons/constants/documents';
import { cpfMask } from 'commons/utils/masks';
import { findDocument } from 'commons/utils/figurant';

import { Item } from './styles';

const mountFigurantData = (foundTutor: IFigurant) => [
  {
    key: 'figurantData_1',
    content: [
      { label: 'Nome Completo', value: foundTutor.name, id: 1 },
      { label: 'Gênero', value: foundTutor.genre, id: 2 },
      {
        label: 'CPF',
        value: cpfMask(findDocument(foundTutor.documents, DocumentType.CPF)?.documentContent || ''),
        id: 3,
      },
      { label: 'ID', value: foundTutor.id, id: 4 },
      {
        label: 'DRT',
        value: findDocument(foundTutor.documents, DocumentType.DRT)?.documentContent || '-',
        id: 5,
      },
    ],
  },
  {
    key: 'figurantData_2',
    content: [
      { label: 'Altura', value: foundTutor.physicalCharacteristic?.height, id: 6 },
      {
        label: 'Tamanho (Roupa / Calçado)',
        value: `${foundTutor.physicalCharacteristic?.shirtSize} / ${foundTutor.physicalCharacteristic?.shoeSize}`,
        id: 7,
      },
      { label: 'Cor do cabelo', value: foundTutor.physicalCharacteristic?.hairColor || '-', id: 8 },
      { label: 'Cor da pele', value: foundTutor.physicalCharacteristic?.skinColor || '-', id: 9 },
      { label: 'Cor dos olhos', value: foundTutor.physicalCharacteristic?.eyeColor, id: 10 },
    ],
  },
];

export const FigurantData = ({ title, figurant }: { figurant: IFigurant; title: string }) => {
  const figurantData = mountFigurantData(figurant);
  const skills = figurant.backgroundActorAttachments.filter(item => item.description);
  const photos = figurant.backgroundActorAttachments.filter(item => !item.description);
  return (
    <Box>
      <Typography fontWeight={600} fontSize="0.875rem">
        {title}
      </Typography>
      <Stack direction="row" justifyContent="space-between" mt={0.5} gap={5}>
        {figurantData.map(({ content, key }) => (
          <Stack key={key} gap={3} width="100%">
            {content.map(({ value, label, id }) => (
              <Box key={id}>
                <Typography lineHeight="1.5rem" fontSize="0.875rem" color="secondary">
                  {label}:
                </Typography>
                <Typography lineHeight="1.5rem" fontSize="1.125rem" color="secondary">
                  {value}
                </Typography>
              </Box>
            ))}
          </Stack>
        ))}
      </Stack>
      {!!skills.length && (
        <>
          <Typography lineHeight="1.5rem" color="secondary" mt={3.5} mb={1}>
            Habilidades:
          </Typography>
          <Stack direction="row" gap={2.5} flexWrap="wrap">
            {skills.map((skill, index) => (
              <Item key={index}>{skill.description}</Item>
            ))}
          </Stack>
        </>
      )}
      {!!photos.length && (
        <>
          <Typography lineHeight="1.5rem" color="secondary" mt={3.5} mb={1}>
            Fotos:
          </Typography>
          <Stack direction="row" gap={2.5} flexWrap="wrap">
            {photos.map(({ uri, id }) => (
              <Avatar key={id} alt={`${id}`} src={uri} variant="rounded" sx={{ width: 88, height: 88 }} />
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
};
